function normalizeOrigin(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed || trimmed === 'null') {
    return null;
  }
  try {
    return new URL(trimmed).origin;
  } catch {
    return null;
  }
}

export function getAllowedPostMessageOrigins(): string[] {
  const raw = process.env.VUE_APP_CHAT_PARENT_ORIGINS ?? '';
  return raw
    .split(',')
    .map((item: string) => normalizeOrigin(item))
    .filter((item: string | null): item is string => Boolean(item));
}

export function isPostMessageSenderOriginAllowed(origin: string): boolean {
  const normalizedOrigin = normalizeOrigin(origin);
  if (!normalizedOrigin) {
    return false;
  }
  const allowed = getAllowedPostMessageOrigins();
  if (allowed.length === 0) {
    if (process.env.NODE_ENV === 'production') {
      console.error('[gx_chat] VUE_APP_CHAT_PARENT_ORIGINS not configured, postMessage rejected');
      return false;
    }
    return true;
  }
  return allowed.includes(normalizedOrigin);
}

export function resolveTrustedSourceUrlForPostMessage(
  event: MessageEvent,
  payloadSource: string | undefined
): string | null {
  if (!isPostMessageSenderOriginAllowed(event.origin)) {
    return null;
  }
  if (!payloadSource) {
    return event.origin;
  }
  try {
    const parsed = new URL(payloadSource);
    return parsed.origin === new URL(event.origin).origin ? payloadSource : null;
  } catch {
    return null;
  }
}
